import styled from 'styled-components';
import getSubjectsType from '../../utils/get-Subject-Types';

type Props = {
  $subject: string;
  $isopen?: boolean;
}

interface propTypes {
  $subject: string,
  $color: number,
  $textcolor: number,
  $hovercolor: number,
  $isopen?: boolean,
  $highlighted?: boolean
}

export const AccordionContainer = styled.div<Props>`
  border-radius: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  ul {
    width: 100%;
  }

  .Link {
    border-radius: 0;
    text-decoration: none;
  }

  li{
    &:last-of-type{
      button{
        ${({ $isopen }) => ($isopen ? 'border-radius: 0 0 10px 10px;' : 'border-radius: 0;')};
      }
    }
  }
`;

export const Button = styled.button<propTypes>`
  font-family: "Museo", sans-serif;
  font-size: 1.1875rem;
  font-weight: 700;
  border: 1px solid #9747FF;
  background-color: #E9D9FF;
  width: 100%;
  min-height: 3.5rem;

  @media (max-width: 600px) {
    height: 5rem;
  }

  display: flex;
  padding: 0 16px !important;
  align-items: center;
  border-radius: 10px;
  ${({ $isopen }) => ($isopen ? 'border-radius: 10px 10px 0 0;' : 'border-radius: 10px;')};
  color: #333;    transition: 300ms ease;
  cursor: pointer;
  font-weight: ${({ $highlighted }) => ($highlighted ? '700' : 500)};
  text-overflow: ellipsis;

  &:hover {
    background-color: ${({ $hovercolor, $subject, theme }) => getSubjectsType({ color: $hovercolor, subject: $subject, theme })};
  }

  &.active {
    border-bottom: 0;
  }

  text-align: left;

  .accordion-button *, .accordion-button.active * {
    padding: 0;
  }

  p {
    font: unset;
    letter-spacing: unset;
    text-align: unset;
    padding: unset;
  }
`;

export const AccordionWrapper = styled.div`
  padding: 0 180px;
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 1000px) {
    padding: 0 92px;  
  }

  @media (max-width: 600px) {
    padding: 0 20px;
  }
`;

export const AccordionContent = styled.div<propTypes>`
  border: 1px solid #9747FF;
  background-color: #E9D9FF;
  border-radius: 0 0 10px 10px;
  padding: 16px 30px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 600px) {
    padding: 16px 90px;
  }

  & > *, .listaBullets, .listaNumerica {
    padding: 0 !important;
  }

  li::marker {
    color: #333 !important;
  }

  & > p {
    margin: 0;
  }
`;
